import React from 'react';

type Props = {
    className: string;
    myDate: any;
    setMySearch: any;
    control: any;
    setControl: any;
    searchParameter: string | string[];
    placeholder: string
    style?: any;
    disabled?: boolean
}

export function SearchInput({ className, myDate, setMySearch, control, setControl, searchParameter, placeholder, style, disabled }: Props) {
    function normalizeText(value: any): string {
        return String(value ?? '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .trim();
    }

    function getNestedPropertyValue(obj: any, path: string): any {
        const keys = path.split('.');
        return keys.reduce((acc, key) => (acc && acc[key] !== undefined) ? acc[key] : undefined, obj);
    }


    function matchesSearchParameter(item: any, parameter: string, inputValue: string): boolean {
        const nestedPropertyValue = getNestedPropertyValue(item, parameter);
        const normalizedValue = normalizeText(nestedPropertyValue);
        return normalizedValue.indexOf(inputValue) >= 0;
    }

    function handleChange(evt: any) {
        const inputValue = normalizeText(evt.target.value);
        const searchParameters = Array.isArray(searchParameter) ? searchParameter : [searchParameter];

        if (inputValue !== "") {
            if (myDate) {
                let search: any = [];
                for (let i = 0; i < myDate.length; i++) {
                    const matches = searchParameters.some((parameter) =>
                        matchesSearchParameter(myDate[i], parameter, inputValue)
                    );
                    if (matches) {
                        search.push(myDate[i]);
                    }
                }
                setMySearch(search);
                if (control === false) {
                    setControl((prev: any) => !prev);
                }
            }
        } else {
            setMySearch([]);
            if (control === true) {
                setControl((prev: any) => !prev);
            }
        }
    }

    return (
        <input
            type='text'
            data-kt-user-table-filter='search'
            className={className}
            placeholder={placeholder}
            style={style}
            disabled={disabled ? disabled : false}
            onChange={handleChange}
        />
    );
}